<template>
    <a-layout-header class="header">
      <div class="logo">
        <a-space>
            <thunderbolt-outlined style="font-size: 24px; color:#00aaff;" />
          <span>trx-pay.top</span>
        </a-space>
      </div>
      <a-button 
        class="customer-support" 
        :href="customerServiceLink" 
        target="_blank"
        type="primary"
        ghost
      >
        客服
      </a-button>
    </a-layout-header>
  </template>
  
  <script>
import { ThunderboltOutlined } from '@ant-design/icons-vue'
  
  export default {
    components: { ThunderboltOutlined },
    props: {
      customerServiceLink: {
        type: String,
        default: '#'
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
  .header {
    background: #1e2a44;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    height: 64px;
    line-height: 64px;
    
    .logo {
      display: flex;
      align-items: center;
      
      span {
        font-size: 1.2em;
        font-weight: bold;
        color:  #ffffff;
        text-shadow: 0 0 5px rgba(0, 170, 255, 0.5);
      }
    }
    
    .customer-support {
      border-radius: 8px;
      box-shadow: 0 0 10px rgba(0, 170, 255, 0.3);
      transition: all 0.3s ease;
      
      &:hover {
        transform: scale(1.05);
        box-shadow: 0 0 15px rgba(0, 170, 255, 0.7);
      }
    }
  }
  </style>